import { Box, Button, Circle, Flex, Text, VStack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { useNotifications, useNotificationsRead } from "@api/hooks";
import { formatSwedishDate } from "@utils/dateUtils";

interface Props {
	onBack?: () => any;
}

interface Notification {
	id: string;
	message: string;
	created: string;
	status: "NEW" | "READ" | string;
	action?: string;
	data?: {
		job?: { id?: string };
		jobId?: string;
		timeReport?: { id?: string };
	};
}

export const NotificationsSidebar: React.FC<Props> = ({ onBack }) => {
	const navigate = useNavigate();
	const { data } = useNotifications();
	const { mutateAsync, isLoading: isUpdating } = useNotificationsRead();

	async function handleClick(notif: Notification) {
		const jobId = notif.data?.job?.id || notif.data?.jobId;
		const timeReportId = notif.data?.timeReport?.id;

		if (notif.status === "NEW") {
			await mutateAsync({
				notificationIds: [notif.id],
			});
		}

		if (notif.action === "OPEN_JOB" && jobId) {
			return navigate(`/uppdrag/${jobId}`);
		}
		if (notif.action === "OPEN_TIME_REPORT") {
			return navigate(timeReportId ? `/rapporter/tidrapporter?id=${timeReportId}` : "/rapporter/tidrapporter");
		}
	}

	function handleMarkAsRead() {
		if (data?.notifications?.length) {
			mutateAsync({
				notificationIds: data.notifications.map((notif: Notification) => notif.id),
			});
		}
	}

	return (
		<Sidebar onBack={onBack} p="1.5rem 0 1.5rem 1.5rem">
			<Button
				borderRadius={"full"}
				size="xs"
				pos="absolute"
				top="20px"
				right="7px"
				px="3"
				onClick={handleMarkAsRead}
				isLoading={isUpdating}
			>
				Markera som lästa
			</Button>
			<VStack spacing={"3"} overflowY={"auto"} h="100vh" pb="20" pt="2" alignItems={"stretch"}>
				{data?.notifications?.map((notif: Notification) => (
					<Box
						key={notif.id}
						borderBottomColor="dividerLight"
						borderBottomStyle={"solid"}
						borderBottomWidth={"1px"}
						pb="4"
						pr="2.5"
						cursor={"pointer"}
						onClick={() => handleClick(notif)}
					>
						<Flex justifyContent={"flex-end"} alignItems={"center"}>
							<Text m="0" fontWeight={"medium"} color="GrayText" fontSize={"sm"}>
								{formatSwedishDate(notif.created, "short")}
							</Text>
							{notif.status === "NEW" && <Circle bg="red.500" size={"2.5"} ml="2" />}
						</Flex>
						<Text m="0" fontSize={"15px"} lineHeight={"short"} color="muted.800">
							{notif.message}
						</Text>
					</Box>
				))}
			</VStack>
		</Sidebar>
	);
};

export default NotificationsSidebar;
